module.exports = __webpack_public_path__ + "img/fire-flame-03.ed88c683.png";